import { useNavigate } from "react-router-dom";
import { ButtonContent, ButtonIcon, Container } from "./ShareStyles";
import TitleStyles from "../../../components/ui/TitleStyles";
import ButtonGroup from "../../../components/ui/ButtonGroup";
import { usePressKit } from "../../../context/PressKitContext";
import PressKitPreview from "../../../components/pressKitPreview/PressKitPreview";

import QRCodeIcon from "../../../img/logged/qrcode.png";
import LinkIcon from "../../../img/logged/link.png";
import ButtonGradient from "../../../components/ui/ButtonGradient";

const Share = () => {
  const navigate = useNavigate();
  const { pressKitData } = usePressKit();

  const publicUrl = `${window.location.origin}/${
    pressKitData?.customUrl || ""
  }`;

  const handleCopyLink = () => {
    navigator.clipboard.writeText(publicUrl);
    alert("Link copiado: " + publicUrl);
  };

  const handleGoToQrCode = () => {
    navigate(`/generate-qrcode`);
  };

  return (
    <Container>
      <TitleStyles>Compartilhe</TitleStyles>

      <ButtonGroup
        onBack={handleCopyLink}
        onNext={handleGoToQrCode}
        backLabel={
          <ButtonContent>
            <ButtonIcon src={LinkIcon} alt="Ícone de link" />
            Copiar Link
          </ButtonContent>
        }
        nextLabel={
          <ButtonContent>
            <ButtonIcon src={QRCodeIcon} alt="Ícone de QR Code" />
            Gerar QR Code
          </ButtonContent>
        }
      />

      <PressKitPreview data={pressKitData} />

      <ButtonGradient onClick={() => navigate(`/${pressKitData?.customUrl}`)}>
        Visualizar PressKit
      </ButtonGradient>
    </Container>
  );
};

export default Share;
